import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import LeadForm from '../components/LeadForm';
import FinanciamentoSimulado from '../components/FinanciamentoSimulado';
import './ImovelPage.css';

const IMOVEIS_DADOS = {
  't2-arcena': {
    titulo: 'Apartamento T2 em Arcena',
    subtitulo: 'Garagem e arrecadação · Arcena · Alverca do Ribatejo',
    preco: '305 000 €',
    tipo: 'T2', quartos: 2, wc: 1, area: '80 m²',
    piso: '1.º Andar', elevador: false, estacionamento: 'Garagem · 1 lugar + arrecadação', ano: null, energia: 'D',
    ref: 'MN-ARC-001',
    zona: 'Arcena, Alverca do Ribatejo',
    destaque: 'Garagem + arrecadação · Cozinha e WC melhorados · Escritório montado',
    descricao: `Um T2 em Arcena que resolve duas das maiores dores de quem procura casa em Alverca do Ribatejo: onde estacionar o carro e onde arrumar tudo o resto.

Situado na Rua João Tarré Ribeiro, este apartamento de 80 m² fica no 1.º andar de um prédio sem elevador — um único lanço de escadas, não um obstáculo real no dia a dia.

O interior foi remodelado, com particular cuidado na cozinha e na casa de banho, que foram melhoradas e modernizadas. A sala é ampla e luminosa, com zona de estar e de jantar integradas, ar condicionado e cortinados que filtram bem a luz sem fechar o espaço.

Tem dois quartos: o principal, com boa dimensão e roupeiro embutido, e um segundo que está atualmente organizado como escritório — secretária, estantes e boa luz natural. Cada vez mais gente trabalha, pelo menos em parte, a partir de casa, e ter este espaço já pronto é uma vantagem que poucos T2 oferecem nesta faixa de preço.

A cozinha está equipada e organizada, com zona própria para refeições do dia a dia.

Do lado prático, este imóvel entrega o que mais pesa nesta zona: garagem individual para 1 carro e arrecadação separada para arrumos, sem depender da rua nem perder espaço dentro de casa.

Arcena fica a poucos minutos do centro de Alverca do Ribatejo, com comércio, serviços, estação de comboios e acessos rodoviários rápidos para Lisboa e para a A1.

Um T2 pronto a habitar, com garagem, arrecadação e um espaço de trabalho já montado — um conjunto difícil de encontrar junto, nesta faixa de preço.`,
    caracteristicas: [
      '2 Quartos (1 atualmente usado como escritório)',
      '1 Casa de banho completa',
      'Sala ampla com zona de estar e jantar',
      'Cozinha equipada com zona de refeições',
      'Cozinha e casa de banho melhoradas',
      'Ar condicionado',
      'Garagem individual · 1 lugar',
      'Arrecadação separada',
      '1.º Andar',
    ],
    remax: 'https://www.remax.pt',
    fotos: [
      'foto_entrada.jpg',
      'foto_sala1.jpg',
      'foto_sala2.jpg',
      'foto_cozinha1.jpg',
      'foto_cozinha2.jpg',
      'foto_cozinha3.jpg',
      'foto_quarto1.jpg',
      'foto_quarto1b.jpg',
      'foto_escritorio1.jpg',
      'foto_escritorio2.jpg',
      'foto_wc.jpg',
    ],
    pasta: 't2-arcena',
  },
  't2-sobralinho': {
    titulo: 'Apartamento T2 no Sobralinho',
    subtitulo: 'A 50 metros da escola · Sobralinho · Vila Franca de Xira',
    preco: '299 000 €',
    tipo: 'T2', quartos: 2, wc: 1, area: '90 m²',
    piso: '2.º Andar', elevador: true, estacionamento: 'Interior · 1 lugar', ano: 2009, energia: 'C',
    ref: 'MN-SBL-001',
    zona: 'Sobralinho, Vila Franca de Xira',
    destaque: 'A 50m da escola · Elevador · Estacionamento interior',
    descricao: `Há uma coisa que este T2 resolve antes de qualquer outra: a escola fica a 50 metros da porta de casa. Não é força de expressão — é a distância real até ao Centro Social do Sobralinho. Para quem tem ou vai ter filhos pequenos, isto muda o dia a dia inteiro: menos trânsito matinal, menos stress a correr contra o relógio, mais dez minutos de sono.

Construído em 2009 e situado no 2.º andar de um prédio com elevador, o apartamento tem 90 m² bem distribuídos por dois quartos, uma casa de banho completa, sala com boa entrada de luz natural e cozinha equipada com acesso direto a varanda.

A varanda é o ponto que surpreende: vista aberta sobre o bairro, com o horizonte a abrir para o lado da lezíria, e sol da tarde para quem gosta de fechar o dia ali, com um café na mão, sem sair de casa.

Inclui ainda um lugar de estacionamento interno — nesta zona, resolver o carro sem depender da rua à noite já vale, por si só, uma boa parte da tranquilidade de viver aqui.

O Sobralinho oferece o equilíbrio que cada vez mais famílias procuram: bairro residencial calmo, com Alverca do Ribatejo — comércio, serviços, escolas e ligações rodoviárias e ferroviárias para Lisboa — a poucos minutos de distância.

Um T2 pronto a habitar, com preço já bem estimado para o mercado atual. Quem procura conforto, praticidade e uma escola literalmente à porta, não vai encontrar muitas oportunidades assim.`,
    caracteristicas: [
      '2 Quartos',
      '1 Casa de banho completa',
      'Sala com boa luz natural',
      'Cozinha equipada com acesso a varanda',
      'Varanda com vista aberta',
      'Elevador',
      'Estacionamento interior · 1 lugar',
      'Construção de 2009',
      'A 50 metros da escola (Centro Social do Sobralinho)',
      '2.º Andar',
    ],
    remax: 'https://www.remax.pt',
    // Atenção: os nomes dos ficheiros desta pasta não correspondem ao que mostram.
    // Ordem pelo conteúdo real: sala → cozinha → varanda → WC → quartos → hall → prédio.
    fotos: [
      'foto_quarto2.jpg',   // sala + cozinha (capa)
      'foto_quarto1.jpg',   // sala · sofá
      'foto_quarto1b.jpg',  // sala · TV
      'foto_predio.jpg',    // sala de jantar
      'foto_garagem.jpg',   // cozinha + jantar
      'foto_quarto2b.jpg',  // cozinha
      'foto_varanda.jpg',   // cozinha
      'foto_sala3.jpg',     // vista da varanda
      'foto_cozinha1.jpg',  // casa de banho
      'foto_entrada1.jpg',  // quarto principal
      'foto_entrada2.jpg',  // quarto principal · roupeiro
      'foto_sala1.jpg',     // 2.º quarto
      'foto_sala2.jpg',     // 2.º quarto · roupeiro
      'foto_cozinha2.jpg',  // corredor
      'foto_cozinha3.jpg',  // hall de entrada
      'foto_wc.jpg',        // exterior do prédio
    ],
    pasta: 't2-sobralinho',
  },
  't3-vila-franca-a1': {
    titulo: 'Apartamento T3 em Vila Franca de Xira',
    subtitulo: 'Garagem Box · Junto à A1 · Vila Franca de Xira',
    preco: '435 000 €',
    tipo: 'T3', quartos: 3, wc: 2, area: '120 m²',
    piso: 'Andar Alto', elevador: true, estacionamento: 'Box fechada · 1 lugar', ano: 2005, energia: 'C',
    ref: 'MN-VFX-002',
    zona: 'Vila Franca de Xira',
    destaque: 'Vista de rio · Box fechada · Acesso imediato à A1',
    descricao: `Um T3 que se destaca pela qualidade dos acabamentos e por uma vista que raramente se encontra neste segmento de preço — vista aberta sobre o rio, a partir da varanda principal.

Com 120 m² bem distribuídos, este apartamento de 2005 foi pensado para quem procura conforto sem abdicar de localização. A sala ampla, com zona de estar e sala de jantar em open space, tem luz natural em abundância e ligação direta à varanda com vista de rio.

A cozinha, equipada e com acesso direto a uma varanda com vista sobre a serra, é um espaço funcional pensado para o dia a dia — com bancada ampla e boa arrumação.

O escritório com boa dimensão é um trunfo para quem trabalha a partir de casa — algo cada vez mais valorizado e cada vez mais raro de encontrar já configurado. O quarto principal tem ar condicionado e roupeiros embutidos.

Duas casas de banho completas, uma delas com hidromassagem, e um hall de entrada em madeira nobre que impõe presença desde o primeiro momento.

A localização é um dos grandes trunfos deste imóvel: a poucos minutos da entrada da A1, com acesso rápido a Lisboa, rodeado de comércio, serviços e restauração — tudo o que o dia a dia exige, à porta de casa.

Inclui garagem box fechada para 1 carro, elevador no prédio e zona de arrumos. Uma oportunidade rara para quem quer espaço, vista e localização estratégica, sem comprometer nenhum dos três.`,
    caracteristicas: [
      '3 Quartos',
      '2 Casas de banho (1 com hidromassagem)',
      'Sala ampla em open space',
      'Cozinha equipada com acesso a varanda',
      'Escritório equipado',
      'Varanda com vista de rio',
      'Garagem box fechada · 1 lugar',
      'Elevador',
      'Ar condicionado no quarto principal',
      'Hall de entrada em madeira nobre',
      'Construção de 2005',
      'Acesso imediato à A1',
    ],
    remax: 'https://www.remax.pt',
    fotos: [
      'foto_predio.jpg',
      'foto_hall.jpg',
      'foto_sala.jpg',
      'foto_sala2.jpg',
      'foto_sala_tv.jpg',
      'foto_jantar.jpg',
      'foto_cozinha.jpg',
      'foto_cozinha2.jpg',
      'foto_escritorio.jpg',
      'foto_quarto.jpg',
      'foto_varanda.jpg',
      'foto_wc_suite.jpg',
      'foto_wc2.jpg',
      'foto_garagem.jpg',
    ],
    pasta: 't3-vila-franca-a1',
  },
  't3-benavente-historica': {
    titulo: 'Moradia T3 no Centro Histórico de Benavente',
    subtitulo: 'Terraço · Sala com lareira · Centro Histórico · Benavente',
    preco: '295 000 €',
    tipo: 'T3', quartos: 3, wc: 2, area: '97 m²',
    piso: 'Moradia 2 Pisos', elevador: false, estacionamento: 'Não', ano: null, energia: 'E',
    ref: '121981481-15',
    zona: 'Centro Histórico, Benavente',
    destaque: 'Terraço · Sala com lareira · Suite · A10 a 6 min · Aeroporto a 38 min',
    descricao: `Uma moradia com carácter, localizada no centro histórico de Benavente, a menos de 400 m do Pelourinho.

Dois pisos, 97 m², 3 quartos (um deles em suite), sala com lareira, cozinha equipada, 2 casas de banho e um terraço para os dias longos de verão.

A casa dispõe de dois acessos independentes: entrada direta pela rua e uma segunda entrada pela cozinha — uma característica típica do casario histórico português.

A 6 minutos da A10, quem aqui vive chega a Lisboa (Gare do Oriente) em 41 minutos e ao Aeroporto Humberto Delgado em 38 minutos, de carro e sem trânsito. Lisboa está mais perto do que parece.

Benavente oferece tudo o que uma família precisa: centro de saúde, rede escolar completa, comércio de proximidade, restaurantes com gastronomia ribatejana autêntica, Parque Ribeirinho do Sorraia, Cais da Vala Nova para desportos náuticos e um centro histórico com identidade própria.

Qualidade de vida real. Sem abrir mão da cidade.`,
    caracteristicas: [
      '3 Quartos (1 suite com WC privativo)',
      '2 Casas de banho',
      'Sala com lareira',
      'Cozinha equipada',
      'Terraço',
      '2 entradas independentes',
      'Moradia de 2 pisos',
      'Centro histórico de Benavente',
      'A10 a 6 minutos',
      'Aeroporto de Lisboa a 38 min',
    ],
    remax: 'https://www.remax.pt',
    // fotos originais, sem edição com IA (o número da porta está desfocado; na sala, um cartão tapa as fotos de família)
    fotos: [
      'fachada.jpg',
      'lp/02-sala.jpg',
      'lp/03-cozinha.jpg',
      'lp/04-quarto.jpg',
      'lp/05-suite.jpg',
      'lp/06-casa-de-banho.jpg',
      'lp/07-terraco.jpg',
      'lp/08-lezirias.jpg',
      'foto_benavente.jpg',
    ],
    pasta: 't3-benavente-historica',
  },
  't3-povos': {
    titulo: 'Apartamento T3 em Vila Franca de Xira',
    subtitulo: 'Com elevador · Povos · Vila Franca de Xira',
    preco: '290 000 €',
    tipo: 'T3', quartos: 3, wc: 2, area: '106 m²', areaArrecadacao: '12 m²',
    piso: '3.º Andar', elevador: true, estacionamento: 'Não', ano: 2003, energia: 'D',
    ref: '121981557-1',
    zona: 'Povos, Vila Franca de Xira',
    destaque: 'A 2 min do Hospital · Acesso rápido A1',
    descricao: `Descubra a sua próxima casa em Povos – Vila Franca de Xira!

Se procura um lar onde conforto, espaço e localização se unem de forma perfeita, este fantástico T3 pode ser exatamente aquilo que sempre imaginou para si e para a sua família.

Situado no 3.º piso de um prédio com elevador, este apartamento destaca-se pelas suas áreas generosas, excelente luminosidade natural e uma organização de espaços pensada para o seu bem-estar no dia a dia.

O imóvel é composto por três quartos com roupeiros embutidos, sendo um deles uma confortável suite, ideal para garantir a sua privacidade e tranquilidade. A sala ampla convida a momentos de convívio e descanso, com luz natural abundante. A cozinha é funcional e perfeita para o dia a dia, complementada por duas casas de banho.

Com uma área de 106 m² e uma arrecadação adicional de 12 m², terá espaço de sobra para organizar tudo o que precisa.

A localização é outro dos grandes pontos fortes: a apenas 2 minutos do Hospital de Vila Franca de Xira, muito próximo de serviços, comércio e com acesso rápido à entrada da A1.`,
    caracteristicas: ['3 Quartos (1 suite)', '2 Casas de banho', 'Sala ampla', 'Cozinha funcional', 'Arrecadação 12 m²', 'Elevador', 'Roupeiros embutidos', 'Boa luminosidade'],
    remax: 'https://www.remax.pt/pt/imoveis/venda-apartamento-t3-lisboa-vila-franca-de-xira/121981557-1/T3RbJnx58b-pS-7i22K4xOJBO3b8_HBJ',
    pasta: 't3-povos',
    numFotos: 4,
  },
  't4-malvarosa': {
    titulo: 'Apartamento T4 em Alverca do Ribatejo',
    subtitulo: 'Com elevador e garagem · Malvarosa · Alverca',
    preco: '689 000 €',
    precoAnterior: '699 000 €',
    tipo: 'T4', quartos: 4, wc: 3, area: '180 m²', areaDependente: '80 m²',
    piso: '6.º Andar', elevador: true, estacionamento: '3+ lugares', ano: 2007, energia: 'C',
    ref: '121981260-247',
    zona: 'Malvarosa, Alverca do Ribatejo',
    destaque: '⬇️ Redução de preço · Garagem 4 carros · Duas frentes',
    descricao: `Um T4 na praça principal da Malvarosa não surge todos os dias. Aqui, tudo acontece à porta: comércio, serviços, restauração e acessos rápidos.

Com 180 m² de área útil e mais 80 m² de área dependente, este apartamento oferece espaço real para quem precisa de conforto sem apertos. As duas frentes garantem luz natural ao longo do dia.

A garagem para 4 carros resolve de uma vez o problema do estacionamento — chegar a casa deixa de ser um stress diário.

A localização permite fazer a maioria das tarefas a pé, poupando tempo e simplificando rotinas. Ideal para famílias que valorizam espaço, centralidade e organização, ou para quem trabalha muito e quer tudo à mão.`,
    caracteristicas: ['4 Quartos', '3 Casas de banho', '180 m² área útil', '80 m² área dependente', 'Garagem 4 carros', 'Duas frentes', 'Luz natural todo o dia', 'Localização central'],
    remax: 'https://www.remax.pt/pt/imoveis/venda-apartamento-t4-lisboa-vila-franca-de-xira/121981260-247/T3RbJnx58b-pS-7i22K4xK8WfJw08FDh',
    pasta: 't4-malvarosa',
    numFotos: 4,
  },
  't3-malvarosa-plaza': {
    titulo: 'Apartamento T3 · Condomínio Plaza',
    subtitulo: 'Condomínio fechado com piscina · Malvarosa · Alverca',
    preco: '545 000 €',
    tipo: 'T3', quartos: 3, wc: 3, area: '169 m²', areaTotal: '217 m²',
    piso: '3.º Andar', elevador: true, estacionamento: '2 lugares', ano: 2010, energia: 'B',
    ref: '121981260-238',
    zona: 'Condomínio Plaza, Malvarosa, Alverca',
    destaque: 'Único condomínio fechado da Malvarosa · Piscina · Jardim · Sala de festas',
    descricao: `Este T3 no Condomínio Fechado PLAZA, na Malvarosa, oferece o equilíbrio entre espaço, conforto e distinção — ideal para famílias em crescimento que procuram mais do que apenas metros quadrados.

Com quase 170 m² de área útil e varandas em todas as divisões, há espaço para respirar em cada canto do dia. No total, são mais de 217 m², incluindo duas garagens individuais.

A sala comum com mais de 40 m² é o lugar ideal para momentos felizes em família. A cozinha, equipada, com espaço de refeições e acesso a varanda virada a sul.

Na zona de descanso encontramos o wc de apoio aos dois quartos e uma suite com closet e wc exclusivo.

Viver aqui é mais do que estar na Malvarosa — é estar no único condomínio fechado da urbanização, com piscina, jardim e sala de festas. Estação de comboios a apenas 2 km.`,
    caracteristicas: ['3 Quartos (1 suite com closet)', '3 Casas de banho', 'Sala 40 m²', 'Varandas em todas as divisões', '2 Garagens individuais', 'Piscina', 'Jardim privativo', 'Sala de festas', 'Comboio a 2 km'],
    remax: 'https://www.remax.pt/pt/imoveis/venda-apartamento-t3-lisboa-vila-franca-de-xira/121981260-238/T3RbJnx58b-pS-7i22K4xKPwsPH975IZ',
    pasta: 't3-malvarosa-plaza',
    numFotos: 4,
  },
  't2-parque-nacoes': {
    titulo: 'Apartamento T2 · Parque das Nações',
    subtitulo: 'Vista de rio · 7.º Andar · Lisboa',
    preco: '685 000 €',
    tipo: 'T2', quartos: 2, wc: 1, area: '107 m²', areaUtil: '84 m²',
    piso: '7.º Andar', elevador: true, estacionamento: '1 lugar', ano: 2009, energia: 'C',
    ref: '121981260-236',
    zona: 'Parque das Nações, Lisboa',
    destaque: 'Vista de rio e cidade · Parque das Nações · Zona premium',
    descricao: `No coração do Parque das Nações, este apartamento T2 combina localização, vista, qualidade e conforto.

Do 7.º andar, a vista de rio e cidade é o primeiro convite a abrandar o ritmo — um cenário diário que transforma pausas em momentos de inspiração.

Com 84 m² de área privativa e 43 m² dependente, este apartamento foi pensado para quem valoriza funcionalidade e espaço, sem abdicar de localização.

A varanda fechada na cozinha permite aproveitar a luz natural e o horizonte, mesmo nos dias mais ventosos. A cozinha totalmente equipada, com uma dimensão agradável e funcional. Inclui lugar de estacionamento.

Rodeado de escolas, supermercados e serviços, este é o ponto onde a conveniência urbana se encontra com o bem-estar.`,
    caracteristicas: ['2 Quartos', '1 Casa de banho', 'Vista de rio do 7.º andar', 'Varanda fechada na cozinha', 'Cozinha totalmente equipada', 'Estacionamento incluído', 'Zona premium Lisboa', 'Próximo de escolas e serviços'],
    remax: 'https://www.remax.pt/pt/imoveis/venda-apartamento-t2-lisboa-lisboa/121981260-236/T3RbJnx58b-pS-7i22K4xJPqJu-RucfW',
    pasta: 't2-parque-nacoes',
    numFotos: 4,
  },
};

function Galeria({ pasta, numFotos, fotosNomes }) {
  const [fotoAtiva, setFotoAtiva] = useState(0);
  const [lightboxAberto, setLightboxAberto] = useState(false);

  const fotos = fotosNomes && fotosNomes.length > 0
    ? fotosNomes.map(nome => `/imoveis/${pasta}/${nome}`)
    : Array.from({ length: numFotos }, (_, i) => `/imoveis/${pasta}/foto-${i + 1}.jpg`);

  const anterior = () => setFotoAtiva(f => (f - 1 + fotos.length) % fotos.length);
  const proximo = () => setFotoAtiva(f => (f + 1) % fotos.length);

  return (
    <div className="galeria">
      <div className="galeria-principal" onClick={() => setLightboxAberto(true)}>
        <img src={fotos[fotoAtiva]} alt={`Foto ${fotoAtiva + 1}`} />
        <div className="galeria-overlay"><span>🔍 Ver em grande</span></div>
        <div className="galeria-contador">{fotoAtiva + 1} / {fotos.length}</div>
        <button className="galeria-nav galeria-nav-esq" onClick={e => { e.stopPropagation(); anterior(); }}>‹</button>
        <button className="galeria-nav galeria-nav-dir" onClick={e => { e.stopPropagation(); proximo(); }}>›</button>
      </div>
      <div className="galeria-thumbs">
        {fotos.map((f, i) => (
          <img key={i} src={f} alt={`Foto ${i + 1}`} className={`thumb ${i === fotoAtiva ? 'ativa' : ''}`} onClick={() => setFotoAtiva(i)} />
        ))}
      </div>
      {lightboxAberto && (
        <div className="lightbox" onClick={() => setLightboxAberto(false)}>
          <button className="lightbox-fechar" onClick={() => setLightboxAberto(false)}>✕</button>
          <button className="lightbox-nav lightbox-esq" onClick={e => { e.stopPropagation(); anterior(); }}>‹</button>
          <img src={fotos[fotoAtiva]} alt={`Foto ${fotoAtiva + 1}`} onClick={e => e.stopPropagation()} />
          <button className="lightbox-nav lightbox-dir" onClick={e => { e.stopPropagation(); proximo(); }}>›</button>
          <div className="lightbox-contador">{fotoAtiva + 1} / {fotos.length}</div>
        </div>
      )}
    </div>
  );
}

export default function ImovelPage() {
  const { slug } = useParams();
  const im = IMOVEIS_DADOS[slug];

  if (!im) return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1rem' }}>
      <h2>Imóvel não encontrado</h2>
      <Link to="/imoveis" style={{ color: 'var(--red)' }}>← Ver todos os imóveis</Link>
    </div>
  );

  const urlPartilha = `https://www.marconevesimobiliario.com/imoveis/${slug}`;
  const textoPartilha = encodeURIComponent(`${im.titulo} · ${im.preco} · ${im.zona}`);

  return (
    <div className="imovel-page">
      <Navbar />

      <div className="imovel-hero">
        <div className="container">
          <div className="imovel-breadcrumb">
            <Link to="/">Início</Link> → <Link to="/imoveis">Imóveis</Link> → <span>{im.tipo}</span>
          </div>
          <div className="imovel-hero-top">
            <div>
              <span className="imovel-tipo-badge">{im.tipo}</span>
              <h1>{im.titulo}</h1>
              <p className="imovel-subtitulo">📍 {im.subtitulo}</p>
              {im.destaque && <p className="imovel-destaque-badge">{im.destaque}</p>}
            </div>
            <div className="imovel-preco-hero">
              {im.precoAnterior && <span className="preco-riscado">{im.precoAnterior}</span>}
              <span className="preco-grande">{im.preco}</span>
              <span className="preco-ref">Ref: {im.ref}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="imovel-body">
        <div className="container imovel-layout">
          <div className="imovel-esq">
            <Galeria pasta={im.pasta} numFotos={im.numFotos} fotosNomes={im.fotos} />

            <div className="imovel-descricao">
              <h2>Descrição</h2>
              {im.descricao.split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
            </div>

            <div className="imovel-caracteristicas">
              <h2>Características</h2>
              <div className="caract-grid">
                {im.caracteristicas.map((c, i) => (
                  <div key={i} className="caract-item">
                    <span className="caract-check">✓</span>
                    <span>{c}</span>
                  </div>
                ))}
              </div>
            </div>

            <FinanciamentoSimulado preco={im.preco} refImovel={im.ref} titulo={im.titulo} />

            <div className="imovel-partilhar">
              <h3>Partilhar este imóvel</h3>
              <div className="partilhar-btns">
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(urlPartilha)}`} target="_blank" rel="noopener noreferrer" className="btn-partilha btn-fb">
                  <span>f</span> Facebook
                </a>
                <a href={`https://wa.me/?text=${textoPartilha}%20${encodeURIComponent(urlPartilha)}`} target="_blank" rel="noopener noreferrer" className="btn-partilha btn-wa">
                  <span>💬</span> WhatsApp
                </a>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="btn-partilha btn-ig" title="Abre o Instagram — partilha manualmente com as fotos">
                  <span>📷</span> Instagram
                </a>
                <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer" className="btn-partilha btn-tt" title="Abre o TikTok — cria vídeo com as fotos">
                  <span>♪</span> TikTok
                </a>
                <button className="btn-partilha btn-copy" onClick={() => { navigator.clipboard.writeText(urlPartilha); alert('Link copiado!'); }}>
                  <span>🔗</span> Copiar link
                </button>
              </div>
              <p className="partilha-nota">* Instagram e TikTok não permitem partilha direta de links externos. Usa as fotos e o link na bio.</p>
            </div>
          </div>

          <aside className="imovel-sidebar">
            <div className="ficha-tecnica">
              <h3>Ficha Técnica</h3>
              <div className="ficha-linha"><span>Tipologia</span><strong>{im.tipo}</strong></div>
              <div className="ficha-linha"><span>Área</span><strong>{im.area}</strong></div>
              {im.areaUtil && <div className="ficha-linha"><span>Área útil</span><strong>{im.areaUtil}</strong></div>}
              {im.areaTotal && <div className="ficha-linha"><span>Área total</span><strong>{im.areaTotal}</strong></div>}
              {im.areaArrecadacao && <div className="ficha-linha"><span>Arrecadação</span><strong>{im.areaArrecadacao}</strong></div>}
              {im.areaDependente && <div className="ficha-linha"><span>Área dependente</span><strong>{im.areaDependente}</strong></div>}
              <div className="ficha-linha"><span>Quartos</span><strong>{im.quartos}</strong></div>
              <div className="ficha-linha"><span>WC</span><strong>{im.wc}</strong></div>
              <div className="ficha-linha"><span>Piso</span><strong>{im.piso}</strong></div>
              <div className="ficha-linha"><span>Elevador</span><strong>{im.elevador ? 'Sim' : 'Não'}</strong></div>
              <div className="ficha-linha"><span>Estacionamento</span><strong>{im.estacionamento}</strong></div>
              {im.ano && <div className="ficha-linha"><span>Ano construção</span><strong>{im.ano}</strong></div>}
              <div className="ficha-linha"><span>Classe energética</span><strong>{im.energia}</strong></div>
              <div className="ficha-linha"><span>Referência</span><strong>{im.ref}</strong></div>
            </div>

            <div className="sidebar-consultor">
              <img src="/marco-fato.jpg" alt="Marco Neves" />
              <h4>Marco Neves</h4>
              <p>Consultor Imobiliário<br/>RE/MAX Grupo Vantagem</p>
              <p className="sc-ami">Licença AMI: 7772</p>
              <a href="tel:+351969692793" className="sc-tel">📞 +351 969 692 793</a>
              <a href={`https://wa.me/351969692793?text=Olá%20Marco,%20estou%20interessado%20no%20imóvel%20${im.ref}%20-%20${encodeURIComponent(im.titulo)}`} target="_blank" rel="noopener noreferrer" className="sc-wa">
                💬 WhatsApp
              </a>
              {im.remax && im.remax !== 'https://www.remax.pt' && (
                <a href={im.remax} target="_blank" rel="noopener noreferrer" className="sc-remax">
                  Ver no RE/MAX →
                </a>
              )}
            </div>

            <div className="sidebar-form">
              <p className="sidebar-form-titulo">Pedir Informações</p>
              <LeadForm
                tipo={`imovel-${im.ref}`}
                titulo="Pedir informações"
                subtitulo="Respondo em menos de 24 horas."
              />
            </div>
          </aside>
        </div>
      </div>

      <div className="outros-imoveis">
        <div className="container">
          <h3>Outros imóveis disponíveis</h3>
          <div className="outros-grid">
            {Object.entries(IMOVEIS_DADOS).filter(([s]) => s !== slug).map(([s, i]) => {
              const capa = i.fotos && i.fotos.length > 0
                ? `/imoveis/${i.pasta}/${i.fotos[0]}`
                : `/imoveis/${i.pasta}/foto-1.jpg`;
              return (
                <Link to={`/imoveis/${s}`} key={s} className="outro-card">
                  <img src={capa} alt={i.titulo} />
                  <div className="outro-info">
                    <span className="outro-tipo">{i.tipo}</span>
                    <p>{i.zona}</p>
                    <strong>{i.preco}</strong>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
